export default function GlobalModals() {
  return <></>
}
